import * as ActionTypes from '../actionTypes';

const initialState = {
    data: [],
    nextPage: undefined,
    loadingPayments: false,
};

export default function reducer(state = initialState, action) {
    let object;
    switch (action.type) {
        case ActionTypes.STARTING_GET_PAYMENT_LIST:
            return { ...state, loadingPayments: true };
        case ActionTypes.FAILED_GET_PAYMENT_LIST:
            return { ...state, loadingPayments: false };
        case ActionTypes.COMPLETE_GET_PAYMENT_LIST:
            const { payments, nextPage, paginated } = action.payload;

            if (paginated) {
                return { ...state, data: [...state.data, ...payments], nextPage, loadingPayments: false };
            }

            return { ...state, data: payments, nextPage, loadingPayments: false };
        case ActionTypes.RESET_PAYMENT_DATA_STORE: {
            return initialState;
        }
        default:
            return state;
    }
}
